import { createAsyncThunk } from '@reduxjs/toolkit';

import { StatementService } from 'api';

import { StatementData } from 'models';

export const getPrincipalRepayment = createAsyncThunk(
	'statement/getPrincipalRepayment',
	async (data: StatementData) => {
		return await StatementService.getPrincipalRepayment(data);
	},
);
